// Default port configuration
const DEFAULT_PORT = 5001;

// User-specific port configurations
const USER_PORTS = {
  'hnaka24': 5001,
  // Add other users and their ports here
};

// Try to get port in this order:
// 1. User-specific port from build
// 2. Port from localStorage (if user changed it)
// 3. Default port
const getPort = () => {
  const userPort = USER_PORTS[process.env.REACT_APP_USER];
  const savedPort = localStorage.getItem('apiPort');
  return savedPort || userPort || DEFAULT_PORT;
};

// Export the API base URL
export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || `http://127.0.0.1:${getPort()}`;

// Allow runtime changes to the port
export const updatePort = (newPort) => {
  if (newPort && !isNaN(newPort)) {
    localStorage.setItem('apiPort', newPort);
    window.location.reload();
  }
};

// Get current port (useful for UI)
export const getCurrentPort = () => getPort();

// Semester configurations — Fall 2026 only for the FY advising pilot.
// Prior semesters' embedding/t-SNE data lives in the amherstcourse pipeline outputs.
export const AVAILABLE_SEMESTERS = ['2627F'];
export const CURRENT_SEMESTER = "2627F";

// Email domains allowed to sign up on this deployment. Per-deployment:
//   Amherst (main):                ['amherst.edu']
//   UPenn (feature/upenn-integration): ['upenn.edu']
// Also accepts any subdomain (e.g. alumni.amherst.edu).
export const ALLOWED_EMAIL_DOMAINS = ['amherst.edu'];

// Map data files served from public/. Swap these when regenerating the map.
export const COURSE_DETAILS_FILE = 'amherst_courses_all.json';
export const TSNE_COORDS_FILE = 'tsne_coords_all_gpt_off_the_shelf_17606150.json';
export const SIMILARITY_FILE = 'output_similarity_all.json';

export function getSemesterDataPaths(semester) {
  return {
    courseDetails: `/${COURSE_DETAILS_FILE}`,
    tsneCoords: `/${TSNE_COORDS_FILE}`,
    similarityData: `/${SIMILARITY_FILE}`,
  };
}

// Configured survey configuration flag (1, 2, 3, or 4)
export const SURVEY_CONFIG = process.env.REACT_APP_SURVEY_CONFIG || "1";

